<template>
  <span>
    <v-card>
      <v-card-text v-if="!selectedEvacuation" class="pb-0">
        <v-card-title class="mb-3 pt-0">
          {{ methodology.name }}
        </v-card-title>
        <v-card-subtitle>
          <div v-html="methodology.details"></div>
        </v-card-subtitle>
      </v-card-text>
      <v-card-text>
        <v-card-title class="mb-3 pt-0">
          <div class="evacuations-container">
            <v-select
              v-model="selectedEvacuation"
              :items="evacuations"
              item-text="name"
              item-value="value"
              label="Evacuation levels"
              clearable
              return-object
            ></v-select>
          </div>
        </v-card-title>
        <v-card-subtitle>
          {{ description }}
        </v-card-subtitle>

        <div class="definition-card-container" v-if="selectedEvacuation">
          <v-card
            v-for="type in types"
            :key="type.value"
            width="230"
            class="pull-left mr-2 definition-card"
          >
            <v-card-title class="text-h6 mb-3">
              <div class="pull-left"></div>
              <div class="pull-left ml-2" style="word-break: keep-all;">
                {{ type.name.toUpperCase() }}
              </div>
              <div class="clearfix"></div>
            </v-card-title>
            <v-card-subtitle class="definition-card-subtitle">
              <p>{{ type.details }}</p>
            </v-card-subtitle>
          </v-card>
          <div class="clearfix"></div>
        </div>

        <div v-if="advices" class="pt-4 pr-5">
          <v-card width="100%">
            <v-card-title>ADVICE</v-card-title>
            <v-card-text>
              <ul>
                <li v-for="(advice, index) in advices" :key="index">
                  {{ advice }}
                </li>
              </ul>
            </v-card-text>
          </v-card>
        </div>
      </v-card-text>
    </v-card>
  </span>
</template>

<script>
import {
  EVACUATION_METHODOLOGY_DESCRIPTION,
  EVACUATION_LEVEL_DESCRIPTIONS,
} from "@/common/constants/controlRisks/evacuations";
import lodashGet from "lodash/get";
import lodashOrderBy from "lodash/orderBy";

export default {
  name: "EvacuationsDescription",
  data() {
    return {
      methodology: EVACUATION_METHODOLOGY_DESCRIPTION,
      evacuations: EVACUATION_LEVEL_DESCRIPTIONS,
      selectedEvacuation: null,
    };
  },
  computed: {
    description() {
      if (lodashGet(this.selectedEvacuation, "description")) {
        return this.selectedEvacuation.description;
      }
      return null;
    },
    types() {
      if (lodashGet(this.selectedEvacuation, "types")) {
        return lodashOrderBy(this.selectedEvacuation.types, ["value"]);
      }
      return null;
    },
    advices() {
      if (lodashGet(this.selectedEvacuation, "advices")) {
        return this.selectedEvacuation.advices;
      }
      return null;
    },
  },
};
</script>

<style scoped>
.evacuations-container {
  width: 400px !important;
}
.definition-card {
  height: 375px;
  overflow-y: auto;
}
.definition-card-subtitle {
  font-size: 12px;
}
.definition-card-container {
  height: 375px;
}
</style>
